/**
 * Suggested answers are the user side of the conversation.
 * Desktop keeps the 692 tile-grid cap. Mobile keeps the same grid
 * (2-across below lg) and only compacts the chips in CSS.
 */
export const QUESTIONNAIRE_OPTIONS_WIDTH_CLASS = "w-[min(692px,100%)]";

export const QUESTIONNAIRE_OPTIONS_CLUSTER_CLASS = [
	"ml-auto flex flex-col items-end gap-4",
	QUESTIONNAIRE_OPTIONS_WIDTH_CLASS,
].join(" ");

/** Space between Q&A turns — larger than the question→tiles gap inside a turn. */
export const QUESTIONNAIRE_TRANSCRIPT_LIST_CLASS = "flex flex-col gap-16 max-md:gap-12";

/** One Q&A turn: question on its own left row, tiles stacked below and right-aligned. */
export const QUESTIONNAIRE_TRANSCRIPT_ROW_BASE_CLASS = "flex w-full flex-col";
export const QUESTIONNAIRE_TRANSCRIPT_ROW_GAP_CLASS = "gap-8 md:gap-12";
export const QUESTIONNAIRE_TRANSCRIPT_ROW_CLASS = [
	QUESTIONNAIRE_TRANSCRIPT_ROW_BASE_CLASS,
	QUESTIONNAIRE_TRANSCRIPT_ROW_GAP_CLASS,
].join(" ");

export const QUESTIONNAIRE_TRANSCRIPT_QUESTION_CLASS = "flex min-w-0 items-start self-start";

export const QUESTIONNAIRE_TRANSCRIPT_OPTIONS_CLASS = "flex w-full justify-end max-md:w-full";

/** 2-across is the default below `lg`. Desktop only adds a third or fourth column. */
export function questionnaireOptionsGridClass(optionCount: number): string {
	if (optionCount >= 6 || optionCount === 3) {
		return "grid w-full grid-cols-3 items-stretch gap-4 max-lg:grid-cols-2 max-md:gap-3";
	}
	if (optionCount === 4) {
		return "grid w-full grid-cols-4 items-stretch gap-4 max-lg:grid-cols-2 max-md:gap-3";
	}
	return "grid w-full grid-cols-2 items-stretch gap-4 max-md:gap-3";
}
